import Vue from "vue";
import axios from "axios";

export default {
  retrieveNotifications({ state, commit }) {
    axios
      .get(
        `${Vue.prototype.$_notifications_config.jiminnyHost()}/api/v1/notifications/recent`
      )
      .then((response) => {
        commit("SET_NOTIFICATIONS", response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  readNotification({ commit }, notification) {
    axios
      .put(
        `${Vue.prototype.$_notifications_config.jiminnyHost()}/api/v1/notifications/read`,
        notification.id
      )
      .then(() => commit("MARK_NOTIFICATION_READ", notification));
  },
  addNotification({ commit }, notification) {
    commit("ADD_NOTIFICATION", notification);
  },
};



// WEBPACK FOOTER //
// ./~/vue-components/notifications/store/actions.js